<template>
  <v-data-table
    :headers="headers"
    :items="activeLoci"
    :items-per-page="10"
    class="elevation-1"
    :sort-by="'alleles'"
    :sort-desc="true"
    @click:row="emitSelect"
  >
    <template slot="no-data">No data </template>
    <template v-slot:items="props">
      <td>{{ props.item.ApplicationType }}</td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    loci: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      activeLoci: this.loci,
      headers: [
        {
          text: 'locus id',
          align: 'start',
          sortable: true,
          value: 'id',
        },
        { text: 'product', value: 'product', sortable: false },
        { text: 'allele number', value: 'alleles', sortable: true },
      ],
    };
  },
  watch: {
    loci(l) {
      this.activeLoci = l;
    },
  },
  methods: {
    emitSelect(e) {
      this.$emit('selectLocusId', e.id);
    },
  },
};
</script>

<style></style>
